import React from "react"
import "./styles.css"

const SplashScreen: React.FC = () => (
  <div
    className="ps-splash-root"
    role="status"
    aria-live="polite"
    aria-label="Chargement de l'application"
  >
    <img src="/splash-logo.jpg" alt="" className="ps-splash-logo" />
    <div className="ps-splash-bar" />
  </div>
)

export default SplashScreen
